import { render, staticRenderFns } from "./VueQuote.vue?vue&type=template&id=5632507d&scoped=true&"
import script from "./VueQuote.vue?vue&type=script&lang=js&"
export * from "./VueQuote.vue?vue&type=script&lang=js&"
import style0 from "./VueQuote.vue?vue&type=style&index=0&id=5632507d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5632507d",
  null
  
)

component.options.__file = "VueQuote.vue"
export default component.exports